import { render, staticRenderFns } from "./OrderCompletePage.vue?vue&type=template&id=0f187816&scoped=true&"
import script from "./OrderCompletePage.vue?vue&type=script&lang=js&"
export * from "./OrderCompletePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f187816",
  null
  
)

export default component.exports